import Vue from 'vue'
import Vuex from 'vuex'

import main from "./modules/main";
import auth from "./modules/auth";
import restaurants from "./modules/restaurants";
import restaurantZones from "./modules/restaurantZones";
import restaurantTables from "./modules/restaurantTables";
import guest from "./modules/guest";
import map from "./modules/map";

Vue.use(Vuex)


export default new Vuex.Store({
  modules:{
    main,auth,restaurants,restaurantZones,restaurantTables,guest,map
  }
})
